import { useAvatarPictures } from './useAvatarPictures';
import { upsertActionToast } from './useToast';
import type { IOnboardingStudent } from '@/interfaces';
import { useI18n } from 'vue-i18n';

export function useStudentAvatarUploads() {
  const { uploadStudentAvatarPicture } = useAvatarPictures();
  const { t } = useI18n();

  async function uploadStudentAvatarPictures(students: IOnboardingStudent[]): Promise<void> {
    let failedCount = 0;
    for (const student of students) {
      if (student.id == null || !student.avatarPictureFile) continue;
      try {
        const saved = await uploadStudentAvatarPicture(student.id, student.avatarPictureFile);
        student.avatarPictureId = saved.avatarPictureId;
        student.avatarUploadFailed = false;
      } catch {
        student.avatarUploadFailed = true;
        failedCount++;
      } finally {
        // Each selected photo is attempted once, even if a later creation step is resubmitted.
        student.avatarPictureFile = null;
      }
    }
    if (failedCount) {
      upsertActionToast(`student-avatar-errors:${students.map((student) => student.id).join(',')}`, {
        message: `${t('students.savedBeforeAvatarUploadFailure', { count: students.length })} ${t('students.avatarUploadFailed', { count: failedCount })}`,
        type: 'error',
        behavior: {
          autoClose: false,
          closeButton: false,
          closeOnClick: false,
          hideProgressBar: true,
          bodyClassName: 'toast-body--rich',
        },
      });
    }
  }

  return { uploadStudentAvatarPictures };
}
